import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "@/layouts/AppShell";
import { AuthShell } from "@/layouts/AuthShell";
import { LeagueShell } from "@/layouts/LeagueShell";
import { ProtectedRoute } from "@/router/ProtectedRoute";
import { PublicRoute } from "@/router/PublicRoute";
import { SplashPage } from "@/pages/SplashPage";
import { LoginPage } from "@/pages/auth/LoginPage";
import { RegisterPage } from "@/pages/auth/RegisterPage";
import { ForgotPasswordPage } from "@/pages/auth/ForgotPasswordPage";
import { HomePage } from "@/pages/HomePage";
import { ProfilePage } from "@/pages/ProfilePage";
import { ComingSoonPage } from "@/pages/ComingSoonPage";
import { LeagueFeedPage } from "@/pages/league/LeagueFeedPage";
import { LeaguePredictionsPage } from "@/pages/league/LeaguePredictionsPage";
import { LeagueStatisticsPage } from "@/pages/league/LeagueStatisticsPage";
import { LeagueRankingPage } from "@/pages/league/LeagueRankingPage";
import { MatchDetailPage } from "@/pages/league/MatchDetailPage";
import { BonusQuestionsAnswerPage } from "@/pages/league/BonusQuestionsAnswerPage";
import { DuelsPage } from "@/pages/league/DuelsPage";
import { CreateDuelPage } from "@/pages/league/CreateDuelPage";
import { LeagueSettingsPage } from "@/pages/league/settings/LeagueSettingsPage";
import { LeagueSettingsGeneralPage } from "@/pages/league/settings/LeagueSettingsGeneralPage";
import { LeagueSettingsScoringPage } from "@/pages/league/settings/LeagueSettingsScoringPage";
import { LeagueSettingsClubsPage } from "@/pages/league/settings/LeagueSettingsClubsPage";
import { LeagueSettingsHistoryPage } from "@/pages/league/settings/LeagueSettingsHistoryPage";
import { LeagueSettingsParticipantsPage } from "@/pages/league/settings/LeagueSettingsParticipantsPage";
import { LeagueSettingsImportPointsPage } from "@/pages/league/settings/LeagueSettingsImportPointsPage";
import { LeagueSettingsBonusQuestionsPage } from "@/pages/league/settings/LeagueSettingsBonusQuestionsPage";
import { LeagueSettingsRoundConfigPage } from "@/pages/league/settings/LeagueSettingsRoundConfigPage";
import { AdminOnlyGuard } from "@/modules/leagues/components/AdminOnlyGuard";
import { MyLeaguesPage } from "@/pages/MyLeaguesPage";
import { CreateLeagueWizard } from "@/pages/league/wizard/CreateLeagueWizard";
import { JoinLeaguePage } from "@/pages/league/JoinLeaguePage";
import { AllMatchesPage } from "@/pages/AllMatchesPage";
import {
  TrophyIllustration,
  WhistleConfettiIllustration,
} from "@/components/atoms/illustrations";
import { ROUTES } from "@/constants/routes";

export const router = createBrowserRouter([
  {
    path: ROUTES.splash,
    element: <SplashPage />,
  },
  {
    element: <PublicRoute />,
    children: [
      {
        element: <AuthShell />,
        children: [
          { path: ROUTES.login, element: <LoginPage /> },
          { path: ROUTES.register, element: <RegisterPage /> },
          { path: ROUTES.forgotPassword, element: <ForgotPasswordPage /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: ROUTES.home, element: <HomePage /> },
          {
            path: ROUTES.matches,
            element: <AllMatchesPage />,
          },
          {
            path: ROUTES.groups,
            element: <MyLeaguesPage />,
          },
          {
            path: ROUTES.ranking,
            element: (
              <ComingSoonPage
                illustration={TrophyIllustration}
                title="Ranking consolidado em breve"
                description="Cada liga já tem seu próprio ranking na aba Estatísticas."
                stageLabel="Módulo Ranking"
              />
            ),
          },
          { path: ROUTES.profile, element: <ProfilePage /> },
          { path: ROUTES.createLeague, element: <CreateLeagueWizard /> },
          { path: ROUTES.joinLeague, element: <JoinLeaguePage /> },
          {
            path: ROUTES.notifications,
            element: (
              <ComingSoonPage
                illustration={WhistleConfettiIllustration}
                title="Central de notificações em breve"
                description="Avisos de rodadas, eventos e movimentações do ranking."
                stageLabel="Módulo Notificações"
              />
            ),
          },
          {
            path: ROUTES.league(":leagueId"),
            element: <LeagueShell />,
            children: [
              { index: true, element: <LeaguePredictionsPage /> },
              { path: "feed", element: <LeagueFeedPage /> },
              { path: "palpites", element: <LeaguePredictionsPage /> },
              { path: "estatisticas", element: <LeagueStatisticsPage /> },
              { path: "ranking", element: <LeagueRankingPage /> },
              { path: "partidas/:matchId", element: <MatchDetailPage /> },
              { path: "perguntas-bonus", element: <BonusQuestionsAnswerPage /> },
              { path: "duelos", element: <DuelsPage /> },
              { path: "duelos/novo/:matchId", element: <CreateDuelPage /> },
              {
                path: "configuracoes",
                children: [
                  { index: true, element: <LeagueSettingsPage /> },
                  { path: "geral", element: <LeagueSettingsGeneralPage /> },
                  { path: "pontuacao", element: <LeagueSettingsScoringPage /> },
                  { path: "clubes", element: <AdminOnlyGuard><LeagueSettingsClubsPage /></AdminOnlyGuard> },
                  { path: "historico", element: <LeagueSettingsHistoryPage /> },
                  { path: "participantes", element: <LeagueSettingsParticipantsPage /> },
                  { path: "importar-pontos", element: <AdminOnlyGuard><LeagueSettingsImportPointsPage /></AdminOnlyGuard> },
                  { path: "perguntas-bonus", element: <AdminOnlyGuard><LeagueSettingsBonusQuestionsPage /></AdminOnlyGuard> },
                  { path: "rodada", element: <AdminOnlyGuard><LeagueSettingsRoundConfigPage /></AdminOnlyGuard> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <SplashPage />,
  },
]);
